export default __webpack_public_path__ + "static/media/Sleevelees_Jacket_M.ba7ce6e2.svg";